module.exports = __webpack_public_path__ + "img/ytg.53aa2ce8.png";